import { useEffect } from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import Header from "@/components/landing-v2/Header";
import Footer from "@/components/landing-v2/Footer";

const CALENDLY_SCRIPT_SRC = "https://assets.calendly.com/assets/external/widget.js";
const CALENDLY_URL =
  "https://calendly.com/viralujpl/konsultacja?hide_event_type_details=1&hide_gdpr_banner=1&text_color=1f2937&primary_color=1a8cff&background_color=ffffff";

const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  visible: (i: number) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.1, duration: 0.5, ease: "easeOut" as const },
  }),
};

const Konsultacja = () => {
  useEffect(() => {
    if (document.querySelector(`script[src="${CALENDLY_SCRIPT_SRC}"]`)) return;
    const script = document.createElement("script");
    script.src = CALENDLY_SCRIPT_SRC;
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <div className="min-h-screen text-gray-900">
      <Header />

      {/* Hero */}
      <section className="relative pt-32 pb-6 px-4 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-[#FEF3EC] via-[#FDE8D8] to-white" />

        <div className="relative z-10 max-w-3xl mx-auto text-center">
          <motion.div initial="hidden" animate="visible" variants={fadeUp} custom={0}>
            <span className="inline-block px-4 py-1.5 rounded-full text-sm font-semibold bg-primary/10 text-primary mb-6">
              Bezpłatnie · 30 minut · Online
            </span>
            <h1
              className="text-4xl sm:text-5xl md:text-6xl font-bold tracking-tight text-gray-900 mb-6"
              style={{ lineHeight: 1.0 }}
            >
              Bezpłatna analiza<br />
              <span className="text-primary">Twojego konta</span><br />
              na Instagramie<span className="text-primary">.</span>
            </h1>
            <p className="text-base md:text-lg text-gray-600 max-w-xl mx-auto leading-relaxed mb-8">
              Porozmawiamy 30 minut. Pokażemy Ci dokładnie co hamuje Twój wzrost
              i co zmienić, żeby Reelsy zaczęły działać.
            </p>
            <Button
              size="lg"
              className="group px-8 py-6 text-base font-semibold bg-primary text-white hover:bg-primary/90 rounded-full shadow-lg shadow-primary/25"
              onClick={() => {
                document.getElementById("calendly")?.scrollIntoView({ behavior: "smooth" });
              }}
            >
              Umów bezpłatną rozmowę
              <ArrowRight className="ml-2 w-4 h-4 transition-transform group-hover:translate-x-1" />
            </Button>
            <p className="mt-3 text-xs text-gray-400">Zero zobowiązań.</p>
          </motion.div>
        </div>
      </section>

      {/* Calendly */}
      <section id="calendly" className="py-6 px-4 bg-white">
        <div className="max-w-3xl mx-auto">
          <style>{`
            .calendly-inline-widget .calendly-spinner > div {
              background-color: #1a8cff !important;
            }
          `}</style>
          <div
            className="calendly-inline-widget rounded-2xl overflow-hidden"
            data-url={CALENDLY_URL}
            style={{ minWidth: 320, height: 700 }}
          />
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Konsultacja;
